import React, { useState, useEffect, useContext } from 'react';
import useSectionStyles from './styles';
import moment from 'moment';
import OptionList from './optionList';
import { useLinkBuilder } from '../../hooks/useLinkBuilder';
import NextImageRenderer from '../nextImageRenderer';
import PageContext from '../../contexts/pageContext';
import { DEFAULT_HEADER_IMAGE_LP } from '../../utils/constants';
import Button from '../../components/button/index';
import Countdown from 'react-countdown';
export default function DesktopHeader({
  header,
  navData,
  isTutorWebsite,
  isLandingPage = false,
  onDownloadAppTriggered,
  extraProps
}) {
  const [isVisible, setIsVisible] = useState(false);
  const { isFixed = true } = header;
  const { isCustomWebsite, isEdit } = useContext(PageContext);
  const logoUrl = useLinkBuilder({ isLink: true, link: '/' });
  const classes = useSectionStyles({ isFixed, isCustomWebsite });
  const optionDataFn = () => {
    let optionsArr = navData;
    let optionsData = [];
    if (optionsArr?.length > 5) {
      optionsData = optionsArr?.slice(0, 4);
    } else {
      optionsData = optionsArr;
    }
    return optionsData;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 220) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    if (header?.effectivePrice) {
      window.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (header?.effectivePrice) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const moreContentFn = () => {
    let optionsArr = navData;
    let moreContent = [];
    if (optionsArr?.length > 5) {
      moreContent = optionsArr?.slice(4);
    }
    return moreContent;
  };

  // console.log(header, 'sakshat header desktop');

  const renderer = ({ days, hours, minutes, seconds }) => {
    if (days === 0 && hours < 24) {
      return (
        <span>
          {hours}h : {minutes}m : {seconds}s
        </span>
      );
    } else {
      let given = moment(header.endDate);
      let current = moment().startOf('day');
      return (
        <span>
          {Math.floor(moment.duration(given.diff(current)).asDays())} {'Days'}
        </span>
      );
    }
  };

  const checkIfOfferIsValid = (endDate = null) =>
    moment().diff(moment(endDate || 0)) < 0;

  const checkForShowDiscount = (
    endDate = null,
    offerPriceValidFor = null,
    discount = 0
  ) => {
    let conversions = extraProps?.conversions || 0;
    if (endDate === null || checkIfOfferIsValid()) {
      if (discount > 0 && offerPriceValidFor === null) {
        return true;
      } else if (
        discount > 0 &&
        offerPriceValidFor !== null &&
        offerPriceValidFor - conversions <= 0
      ) {
        return false;
      }
    } else if (offerPriceValidFor >= null && discount) {
      if (offerPriceValidFor <= conversions) {
        return false;
      }
      if (offerPriceValidFor - conversions < 0) {
        return false;
      } else {
        return true;
      }
    }
    if (discount > 0) {
      return true;
    }
  };

  const getDiscount = (price, discount) => {
    return ((discount / price) * 100).toFixed(2);
  };

  const OfferDetailsJSX = () => {
    console.log('header', header);
    if (!header?.effectivePrice || (!isVisible && !isEdit)) {
      return null;
    }
    let conversions = extraProps?.conversions || 0;
    const currentTimestamp = new Date().getTime();
    if (
      checkForShowDiscount(
        header?.endDate,
        header?.offerPriceValidFor,
        header?.discount
      ) && header?.endDate
        ? checkIfOfferIsValid(header?.endDate)
        : true
    ) {
      return (
        <div className={classes.rightNav}>
          {header?.isOfferActive &&
          header?.endDate &&
          header?.endDate &&
          header?.endDate > currentTimestamp &&
          (header?.offerPriceValidFor
            ? header.offerPriceValidFor - conversions > 0
            : true) ? (
            <div className={classes.offerBox}>
              <div className={classes.offerBoxText}>Offer Ends In</div>
              <div className={classes.offerBoxCountDown}>
                <Countdown renderer={renderer} date={header?.endDate} />
              </div>
            </div>
          ) : null}
          <div className={classes.priceBox}>
            {header?.price &&
            header?.discount &&
            header?.effectivePrice &&
            header?.price !== header?.effectivePrice ? (
              <div>
                <span className={classes.offerDiscount}>
                  {`${getDiscount(header?.price, header?.discount)}%`}
                  &nbsp;OFF
                </span>
                &nbsp;&nbsp;
                <span className={classes.originalPrice}>
                  ₹ {header?.price}
                </span>{' '}
              </div>
            ) : null}
            {header?.effectivePrice ? (
              <div style={{ textAlign: 'end' }}>
                <span className={classes.offerPrice}>
                  ₹ {header?.effectivePrice}
                </span>
              </div>
            ) : null}
          </div>
          <Button
            data={{
              // link: 'headerData?.loginCtaLink',
              // isLink: 1,
              value: 'BUY NOW'
              // isExternal: 1
            }}
            onClick={extraProps?.courseBuyNow}
            type={'primary'}
            size={'small'}
            target={null}
            name="button"
            rel={null}
            // styling={isMobile ? { margin: '0 40px' } : {}}
          />
        </div>
      );
    } else
      return (
        <Button
          data={{
            // link: 'headerData?.loginCtaLink',
            // isLink: 1,
            value: 'BUY NOW'
            // isExternal: 1
          }}
          onClick={extraProps?.courseBuyNow}
          type={'primary'}
          size={'medium'}
          target={null}
          name="button"
          rel={null}
          // styling={isMobile ? { margin: '0 40px' } : {}}
        />
      );
  };

  return (
    <nav className={classes.section}>
      {!(header?.websiteLogo === DEFAULT_HEADER_IMAGE_LP && isCustomWebsite) ? (
        <div className={classes.headerSection}>
          <div className={classes.headerContainer}>
            <div className={classes.imageDiv}>
              {header?.websiteLogo ? (
                <a
                  href={logoUrl}
                  className={classes.imageAnchor}
                  style={{
                    pointerEvents: isLandingPage ? 'none' : 'auto',
                    cursor: isLandingPage ? 'not-allowed' : 'default'
                  }}
                >
                  {/* <img src={header?.websiteLogo} /> */}
                  <div className={classes?.imageDivImage}>
                    <NextImageRenderer
                      src={header?.websiteLogo}
                      className={classes.imageDivImageNext}
                      order={1}
                    />
                  </div>
                </a>
              ) : null}

              {isTutorWebsite && header?.appName ? (
                <a href={logoUrl}>
                  <p className={classes.appNameClass}> {header?.appName}</p>
                </a>
              ) : null}
            </div>
            <OptionList
              optionsData={optionDataFn()}
              navDataCount={navData?.length}
              headerData={header}
              isMobile={false}
              isLandingPages={isLandingPage}
              moreContent={moreContentFn()}
              isTutorWebsite={isTutorWebsite}
              onDownloadAppTriggered={onDownloadAppTriggered}
            />
            {OfferDetailsJSX()}
          </div>
        </div>
      ) : (
        <div
          style={{
            paddingTop: '30px'
          }}
        ></div>
      )}
    </nav>
  );
}
